import air from "../icons/air.svg";
import earth from "../icons/earth.svg";
import fire from "../icons/fire.svg";
import water from "../icons/water.svg";

const data = {
  elements: [
    {
      id: 0,
      name: "air",
      image: air,
      selected: "false",
    },

    {
      id: 1,
      name: "earth",
      image: earth,
      selected: "false",
    },
    {
      id: 2,
      name: "fire",
      image: fire,
      selected: "false",
    },
    {
      id: 3,
      name: "water",
      image: water,
      selected: "false",
    },
  ],
};
export default data;
